<select class="form-control input-sm" [(ngModel)]="selectedState" [disabled]="readonly"
        (ngModelChange)="onChangeCb(selectedState)">
  <option selected="true"></option>
  <option *ngFor="let state of states$ | async;" [value]="state.name">
    {{state.label}}
  </option>
</select>
